/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import get from 'lodash/get';

import {
  GET_ORGANIZATIONS_DATA,
  GET_ORGANIZATIONS_DATA_FAILURE,
  GET_ORGANIZATIONS_DATA_SUCCESS,
  GET_ORGANIZATION_BY_ID_DATA,
  GET_ORGANIZATION_BY_ID_DATA_FAILURE,
  GET_ORGANIZATION_BY_ID_DATA_SUCCESS,
  GET_SITES_FOR_ORGANIZATION_DATA,
  GET_SITES_FOR_ORGANIZATION_DATA_FAILURE,
  GET_SITES_FOR_ORGANIZATION_DATA_SUCCESS,
  GET_SITE_DATA,
  GET_SITE_DATA_FAILURE,
  GET_SITE_DATA_SUCCESS,
  GET_SYSTEMS_FOR_SITE_DATA,
  GET_SYSTEMS_FOR_SITE_DATA_FAILURE,
  GET_SYSTEMS_FOR_SITE_DATA_SUCCESS,
  GET_SYSTEMS_FOR_SITE_LOCATION_DATA,
  GET_SYSTEMS_FOR_SITE_LOCATION_DATA_FAILURE,
  GET_SYSTEMS_FOR_SITE_LOCATION_DATA_SUCCESS,
  GET_LOCATIONS_FOR_SITE_DATA,
  GET_LOCATIONS_FOR_SITE_DATA_FAILURE,
  GET_LOCATIONS_FOR_SITE_DATA_SUCCESS,
  GET_SYSTEM_BY_ID_FOR_SITE_DATA,
  GET_SYSTEM_BY_ID_FOR_SITE_DATA_FAILURE,
  GET_SYSTEM_BY_ID_FOR_SITE_DATA_SUCCESS,
  GET_LOCATIONS_FOR_SYSTEM_DATA,
  GET_LOCATIONS_FOR_SYSTEM_DATA_FAILURE,
  GET_LOCATIONS_FOR_SYSTEM_DATA_SUCCESS,
  GET_LOCATION_BY_ID_FOR_SITE_DATA,
  GET_LOCATION_BY_ID_FOR_SITE_DATA_FAILURE,
  GET_LOCATION_BY_ID_FOR_SITE_DATA_SUCCESS,
  GET_SUBLOCATIONS_FOR_SYSTEM_DATA,
  GET_SUBLOCATIONS_FOR_SYSTEM_DATA_FAILURE,
  GET_SUBLOCATIONS_FOR_SYSTEM_DATA_SUCCESS,
  GET_ASSET_TYPES_DATA,
  GET_ASSET_TYPES_DATA_FAILURE,
  GET_ASSET_TYPES_DATA_SUCCESS,
  GET_ASSETS_FOR_ASSET_TYPE_DATA,
  GET_ASSETS_FOR_ASSET_TYPE_DATA_FAILURE,
  GET_ASSETS_FOR_ASSET_TYPE_DATA_SUCCESS,
  CLEAR_ASSETS_FOR_ASSET_TYPE,
  GET_ASSETS_FOR_LOCATION_DATA,
  GET_ASSETS_FOR_LOCATION_DATA_FAILURE,
  GET_ASSETS_FOR_LOCATION_DATA_SUCCESS,
  GET_ASSETS_FOR_SITE_DATA,
  GET_ASSETS_FOR_SITE_DATA_FAILURE,
  GET_ASSETS_FOR_SITE_DATA_SUCCESS,
  GET_ASSET_BY_ID_FOR_SITE_DATA,
  GET_ASSET_BY_ID_FOR_SITE_DATA_FAILURE,
  GET_ASSET_BY_ID_FOR_SITE_DATA_SUCCESS,
  GET_PARENT_ASSETS_FOR_ASSET_DATA,
  GET_PARENT_ASSETS_FOR_ASSET_DATA_FAILURE,
  GET_PARENT_ASSETS_FOR_ASSET_DATA_SUCCESS,
  CLEAR_PARENT_ASSETS,
  GET_SUBASSETS_FOR_ASSET_DATA,
  GET_SUBASSETS_FOR_ASSET_DATA_FAILURE,
  GET_SUBASSETS_FOR_ASSET_DATA_SUCCESS,
  CLEAR_SUBASSETS,
  GET_DEVICES_FOR_ASSET_DATA,
  GET_DEVICES_FOR_ASSET_DATA_FAILURE,
  GET_DEVICES_FOR_ASSET_DATA_SUCCESS,
  GET_DEVICE_TYPES_DATA,
  GET_DEVICE_TYPES_DATA_FAILURE,
  GET_DEVICE_TYPES_DATA_SUCCESS,
  UPDATE_DEVICE_TYPE_DATA,
  UPDATE_DEVICE_TYPE_DATA_FAILURE,
  UPDATE_DEVICE_TYPE_DATA_SUCCESS,
  GET_DEVICE_TYPE_DATA,
  GET_DEVICE_TYPE_DATA_FAILURE,
  GET_DEVICE_TYPE_DATA_SUCCESS,
  GET_DEVICES_FOR_DEVICE_TYPE_DATA,
  GET_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE,
  GET_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS,
  GET_DEVICES_FOR_LOCATION_DATA,
  GET_DEVICES_FOR_LOCATION_DATA_FAILURE,
  GET_DEVICES_FOR_LOCATION_DATA_SUCCESS,
  CLEAR_DEVICES_FOR_DEVICE_TYPE,
  CLEAR_HIERARCHIES,
  PERSIST_HIERARCHY_TABLE,
  CLEAN_PERSIST_HIERARCHY_TABLE,
  GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA,
  GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_FAILURE,
  GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_SUCCESS,
  UPDATE_DEVICE_ALIAS,
  UPDATE_DEVICE_ALIAS_FAILURE,
  UPDATE_DEVICE_ALIAS_SUCCESS,
  GET_DEVICE_DETAILS_DATA,
  GET_DEVICE_DETAILS_DATA_FAILURE,
  GET_DEVICE_DETAILS_DATA_SUCCESS,
  UPDATE_DIMENSIONS_FOR_DEVICE_TYPE,
  UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  CREATE_DIMENSIONS_FOR_DEVICE_TYPE,
  CREATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  CREATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  UPDATE_METRICS_FOR_DEVICE_TYPE,
  UPDATE_METRICS_FOR_DEVICE_TYPE_SUCCESS,
  UPDATE_METRICS_FOR_DEVICE_TYPE_FAILURE,
  CREATE_DEVICES_FOR_DEVICE_TYPE_DATA,
  CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE,
  CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS,
  DELETE_DIMENSIONS_FOR_DEVICE_TYPE,
  DELETE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS,
  DELETE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE,
  DELETE_METRICS_FOR_DEVICE_TYPE,
  DELETE_METRICS_FOR_DEVICE_TYPE_SUCCESS,
  DELETE_METRICS_FOR_DEVICE_TYPE_FAILURE,
  GET_DIMENSIONS_FOR_DEVICE,
  UPDATE_DIMENSIONS_FOR_DEVICE,
  CREATE_DIMENSIONS_FOR_DEVICE,
  GET_DIMENSIONS_FOR_DEVICE_FAILURE,
  UPDATE_DIMENSIONS_FOR_DEVICE_FAILURE,
  CREATE_DIMENSIONS_FOR_DEVICE_FAILURE,
  GET_DIMENSIONS_FOR_DEVICE_SUCCESS,
  UPDATE_DIMENSIONS_FOR_DEVICE_SUCCESS,
  CREATE_DIMENSIONS_FOR_DEVICE_SUCCESS,
  GET_DEVICE_DIMENSIONS_DATA,
  GET_DEVICE_DIMENSIONS_DATA_FAILURE,
  GET_DEVICE_DIMENSIONS_DATA_SUCCESS,
} from 'hierarchiesActionCreators';
import {
  ARCHIVE_HIERARCHY_ITEM_SUCCESS,
  RESTORE_HIERARCHY_ITEM_SUCCESS,
} from 'archivesActionCreators';
import {
  getLeafIdFromHierarchyPath,
  tableDataWithArchivedItem,
  tableDataWithRestoredItem,
} from 'hierarchyUtils';
import { ResourceSatus } from 'HierarchyTypes';

const initialHiearchiesState = {
  organizationsData: [],
  fetchingData: false,
  fetchDataError: null,
  updateDataError: null,
  sitesData: [],
  systemsData: [],
  locationsData: [],
  locationsForSiteData: [],
  sublocationsData: [],
  assetTypesData: [],
  assetsData: [],
  parentAssetsData: [],
  subAssetsData: [],
  deviceTypeData: [],
  deviceTypesData: [],
  devicesData: [],
  dimensionsData: [],
  deviceTypeDimensionsData: [],
  deviceData: [],
  newDevices: [],
  hierarchyTableState: {
    tableData: null,
    expandedIds: null,
  },
};

export const hierarchiesReducer = (state = initialHiearchiesState, action) => {
  // eslint-disable-next-line radar/max-switch-cases
  switch (action.type) {
    case GET_ORGANIZATIONS_DATA:
    case GET_ORGANIZATION_BY_ID_DATA:
    case GET_SITES_FOR_ORGANIZATION_DATA:
    case GET_SITE_DATA:
    case GET_SYSTEMS_FOR_SITE_DATA:
    case GET_SYSTEMS_FOR_SITE_LOCATION_DATA:
    case GET_LOCATIONS_FOR_SITE_DATA:
    case GET_SYSTEM_BY_ID_FOR_SITE_DATA:
    case GET_LOCATIONS_FOR_SYSTEM_DATA:
    case GET_LOCATION_BY_ID_FOR_SITE_DATA:
    case GET_SUBLOCATIONS_FOR_SYSTEM_DATA:
    case GET_ASSET_TYPES_DATA:
    case GET_ASSETS_FOR_ASSET_TYPE_DATA:
    case GET_ASSETS_FOR_LOCATION_DATA:
    case GET_ASSETS_FOR_SITE_DATA:
    case GET_ASSET_BY_ID_FOR_SITE_DATA:
    case GET_PARENT_ASSETS_FOR_ASSET_DATA:
    case GET_SUBASSETS_FOR_ASSET_DATA:
    case GET_DEVICES_FOR_ASSET_DATA:
    case GET_DEVICE_TYPES_DATA:
    case UPDATE_DEVICE_TYPE_DATA:
    case GET_DEVICES_FOR_DEVICE_TYPE_DATA:
    case GET_DEVICES_FOR_LOCATION_DATA:
    case GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA:
    case CREATE_DEVICES_FOR_DEVICE_TYPE_DATA:
    case GET_DEVICE_TYPE_DATA:
    case UPDATE_DEVICE_ALIAS:
    case GET_DEVICE_DETAILS_DATA:
    case UPDATE_DIMENSIONS_FOR_DEVICE_TYPE:
    case CREATE_DIMENSIONS_FOR_DEVICE_TYPE:
    case DELETE_DIMENSIONS_FOR_DEVICE_TYPE:
    case UPDATE_METRICS_FOR_DEVICE_TYPE:
    case DELETE_METRICS_FOR_DEVICE_TYPE:
    case GET_DIMENSIONS_FOR_DEVICE:
    case UPDATE_DIMENSIONS_FOR_DEVICE:
    case CREATE_DIMENSIONS_FOR_DEVICE:
    case GET_DEVICE_DIMENSIONS_DATA:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case GET_ORGANIZATIONS_DATA_FAILURE:
    case GET_ORGANIZATION_BY_ID_DATA_FAILURE:
    case GET_SITES_FOR_ORGANIZATION_DATA_FAILURE:
    case GET_SYSTEMS_FOR_SITE_DATA_FAILURE:
    case GET_SYSTEMS_FOR_SITE_LOCATION_DATA_FAILURE:
    case GET_LOCATIONS_FOR_SITE_DATA_FAILURE:
    case GET_SYSTEM_BY_ID_FOR_SITE_DATA_FAILURE:
    case GET_SITE_DATA_FAILURE:
    case GET_LOCATIONS_FOR_SYSTEM_DATA_FAILURE:
    case GET_LOCATION_BY_ID_FOR_SITE_DATA_FAILURE:
    case GET_SUBLOCATIONS_FOR_SYSTEM_DATA_FAILURE:
    case GET_ASSET_TYPES_DATA_FAILURE:
    case GET_ASSETS_FOR_ASSET_TYPE_DATA_FAILURE:
    case GET_ASSETS_FOR_LOCATION_DATA_FAILURE:
    case GET_ASSETS_FOR_SITE_DATA_FAILURE:
    case GET_ASSET_BY_ID_FOR_SITE_DATA_FAILURE:
    case GET_PARENT_ASSETS_FOR_ASSET_DATA_FAILURE:
    case GET_SUBASSETS_FOR_ASSET_DATA_FAILURE:
    case GET_DEVICES_FOR_ASSET_DATA_FAILURE:
    case GET_DEVICE_TYPES_DATA_FAILURE:
    case UPDATE_DEVICE_TYPE_DATA_FAILURE:
    case GET_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE:
    case GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_FAILURE:
    case GET_DEVICE_TYPE_DATA_FAILURE:
    case GET_DEVICES_FOR_LOCATION_DATA_FAILURE:
    case UPDATE_DEVICE_ALIAS_FAILURE:
    case GET_DEVICE_DETAILS_DATA_FAILURE:
    case UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE:
    case CREATE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE:
    case DELETE_DIMENSIONS_FOR_DEVICE_TYPE_FAILURE:
    case UPDATE_METRICS_FOR_DEVICE_TYPE_FAILURE:
    case DELETE_METRICS_FOR_DEVICE_TYPE_FAILURE:
    case GET_DIMENSIONS_FOR_DEVICE_FAILURE:
    case UPDATE_DIMENSIONS_FOR_DEVICE_FAILURE:
    case CREATE_DIMENSIONS_FOR_DEVICE_FAILURE:
    case GET_DEVICE_DIMENSIONS_DATA_FAILURE:
    case CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_FAILURE:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
        updateDataError: action.payload,
      };
    case GET_ORGANIZATIONS_DATA_SUCCESS:
    case GET_ORGANIZATION_BY_ID_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        organizationsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.organizationsData.filter(
            org => !action.payload.find(newOrg => newOrg.uuid === org.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid  have been filtered out
          ...action.payload,
        ],
      };
    case GET_SITES_FOR_ORGANIZATION_DATA_SUCCESS:
    case GET_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        sitesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.sitesData.filter(
            site =>
              !action.payload.find(
                newSite => newSite.uuid === site.uuid && newSite.orgDDId === site.orgDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and orgDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_SYSTEMS_FOR_SITE_DATA_SUCCESS:
    case GET_SYSTEMS_FOR_SITE_LOCATION_DATA_SUCCESS:
    case GET_SYSTEM_BY_ID_FOR_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        systemsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.systemsData.filter(
            system =>
              !action.payload.find(
                newSystem =>
                  newSystem.uuid === system.uuid && newSystem.siteDDId === system.siteDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };

    case GET_LOCATIONS_FOR_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        locationsForSiteData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.locationsData.filter(
            location =>
              !action.payload.results.find(
                newLocation =>
                  newLocation.uuid === location.uuid && newLocation.siteUUId === location.siteUUId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload.results,
        ],
      };
    case GET_LOCATION_BY_ID_FOR_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        locationsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.locationsData.filter(
            location => !action.payload.find(newLocation => newLocation.uuid === location.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_LOCATIONS_FOR_SYSTEM_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        locationsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.locationsData.filter(
            location =>
              !action.payload.find(
                newLocation =>
                  newLocation.uuid === location.uuid && newLocation.siteDDId === location.siteDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_SUBLOCATIONS_FOR_SYSTEM_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        sublocationsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.sublocationsData.filter(
            sublocation =>
              !action.payload.find(
                newSublocation =>
                  newSublocation.uuid === sublocation.uuid &&
                  newSublocation.siteDDId === sublocation.siteDDId &&
                  newSublocation.systemDDId === sublocation.systemDDId &&
                  newSublocation.parentLocationDDId === sublocation.parentLocationDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_ASSET_TYPES_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        assetTypesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.assetTypesData.filter(
            assetType => !action.payload.find(newAssetType => newAssetType.uuid === assetType.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid have been filtered out
          ...action.payload,
        ],
      };
    case GET_ASSETS_FOR_ASSET_TYPE_DATA_SUCCESS:
    case GET_ASSETS_FOR_LOCATION_DATA_SUCCESS:
    case GET_ASSETS_FOR_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        assetsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.assetsData.filter(
            asset =>
              !action.payload.results.find(
                newAsset =>
                  newAsset.uuid === asset.uuid && newAsset.assetTypeDDId === asset.assetTypeDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and assetTypeDDId have been filtered out
          ...action.payload.results,
        ],
      };
    case GET_ASSET_BY_ID_FOR_SITE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        assetsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.assetsData.filter(
            asset => !action.payload.find(newAsset => newAsset.uuid === asset.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_PARENT_ASSETS_FOR_ASSET_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        parentAssetsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.parentAssetsData.filter(
            asset => !action.payload.find(newAsset => newAsset.uuid === asset.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload,
        ],
      };
    case GET_SUBASSETS_FOR_ASSET_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        subAssetsData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.subAssetsData.filter(
            asset => !action.payload.results.find(newAsset => newAsset.uuid === asset.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and siteDDId have been filtered out
          ...action.payload.results,
        ],
      };
    case GET_DEVICE_TYPES_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceTypesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.deviceTypesData.filter(
            deviceType =>
              !action.payload.results.find(newDeviceType => newDeviceType.uuid === deviceType.uuid)
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid have been filtered out
          ...action.payload.results,
        ],
      };
    case UPDATE_DEVICE_TYPE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceTypesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.deviceTypesData.filter(deviceType => action.payload.uuid !== deviceType.uuid),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid have been filtered out
          ...action.payload,
        ],
      };

    case GET_DEVICE_TYPE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceTypeData: action.payload,
        deviceTypesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.deviceTypesData.filter(deviceType => deviceType.uuid !== action.payload.uuid),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid have been filtered out
          ...action.payload,
        ],
      };
    case GET_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS:
    case GET_DEVICES_FOR_LOCATION_DATA_SUCCESS:
    case GET_DEVICES_FOR_ASSET_DATA_SUCCESS:
    case GET_DEVICE_DIMENSIONS_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        devicesData: [
          // Make sure we first remove existing state resources that are included in the payload, so that this state update becomes a union operation
          ...state.devicesData.filter(
            device =>
              !action.payload.results.find(
                newDevice =>
                  newDevice.uuid === device.uuid &&
                  newDevice.deviceTypeDDId === device.deviceTypeDDId
              )
          ),
          // Include the resources from the payload, they won't create duplicates as all resources with matching uuid and deviceTypeDDId have been filtered out
          ...action.payload.results,
        ],
      };

    case GET_DIMENSIONS_FOR_DEVICE_TYPE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceTypeDimensionsData: action.payload,
      };
    case GET_DIMENSIONS_FOR_DEVICE_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        dimensionsData: action.payload,
      };

    case UPDATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS:
    case DELETE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS:
    case CREATE_DIMENSIONS_FOR_DEVICE_TYPE_SUCCESS:
    case UPDATE_METRICS_FOR_DEVICE_TYPE_SUCCESS:
    case DELETE_METRICS_FOR_DEVICE_TYPE_SUCCESS:
    case UPDATE_DIMENSIONS_FOR_DEVICE_SUCCESS:
    case CREATE_DIMENSIONS_FOR_DEVICE_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
      };
    case UPDATE_DEVICE_ALIAS_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceData: {
          ...state.devicesData.find(device => device.uuid === action.payload.uuid),
          ...action.payload,
        },
      };

    case CREATE_DEVICES_FOR_DEVICE_TYPE_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        newDevices: action.payload,
      };
    case GET_DEVICE_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        deviceData: action.payload,
      };

    case CLEAR_DEVICES_FOR_DEVICE_TYPE:
      return {
        ...state,
        devicesData: [],
      };
    case CLEAR_ASSETS_FOR_ASSET_TYPE:
      return {
        ...state,
        assetsData: [],
      };

    case CLEAR_HIERARCHIES: {
      return {
        ...initialHiearchiesState,
      };
    }

    case PERSIST_HIERARCHY_TABLE: {
      const { tableData, expandedId, expanded } = action.payload;
      return {
        ...state,
        hierarchyTableState: {
          tableData: tableData ?? state?.hierarchyTableState?.tableData,
          expandedIds: expanded
            ? [...(state?.hierarchyTableState?.expandedIds ?? []), expandedId]
            : state?.hierarchyTableState?.expandedIds?.filter(i => i !== expandedId) ?? [],
        },
      };
    }

    case CLEAN_PERSIST_HIERARCHY_TABLE: {
      return {
        ...state,
        hierarchyTableState: { tableData: null, expandedIds: null },
      };
    }

    case CLEAR_PARENT_ASSETS: {
      return {
        ...state,
        parentAssetsData: [],
      };
    }

    case CLEAR_SUBASSETS: {
      return {
        ...state,
        subAssetsData: [],
      };
    }

    // Make sure that any archived item is removed from the state, so that there is no need to reload the entire tree and lists whenever an item is archived
    case ARCHIVE_HIERARCHY_ITEM_SUCCESS:
      return {
        ...state,
        sitesData: [],
        systemsData: [],
        locationsData: [
          ...state.locationsData.filter(
            location => location.uuid !== getLeafIdFromHierarchyPath(action.payload)
          ),
        ],
        sublocationsData: [
          ...state.sublocationsData.filter(
            sublocation => sublocation.uuid !== getLeafIdFromHierarchyPath(action.payload)
          ),
        ],
        assetTypesData: [
          ...state.assetTypesData.filter(
            assetType => assetType.uuid !== getLeafIdFromHierarchyPath(action.payload)
          ),
        ],
        assetsData: [
          ...state.assetsData.filter(
            asset => asset.uuid !== getLeafIdFromHierarchyPath(action.payload)
          ),
        ],
        deviceTypesData: [
          ...state.deviceTypesData.filter(
            deviceType => deviceType.uuid !== getLeafIdFromHierarchyPath(action.payload)
          ),
        ],
        hierarchyTableState: {
          ...state.hierarchyTableState,
          tableData: state.hierarchyTableState.tableData
            ? tableDataWithArchivedItem(state.hierarchyTableState.tableData, action.payload)
            : null,
        },
      };

    case RESTORE_HIERARCHY_ITEM_SUCCESS:
      return {
        ...state,
        hierarchyTableState: {
          ...state.hierarchyTableState,
          tableData: state.hierarchyTableState.tableData
            ? tableDataWithRestoredItem(state.hierarchyTableState.tableData, action.payload)
            : null,
        },
      };

    default:
      return state;
  }
};

// export const getSelectedKPILog = state => get(state, 'selectedKPILog.data') || {};
export const getHierarchiesFetchDataError = state => get(state, 'hierarchies.fetchDataError');
export const getHierarchiesUpdateDataError = state => get(state, 'hierarchies.updateDataError');
export const getHierarchiesFetchingData = state => get(state, 'hierarchies.fetchingData');

export const getHierarchies = state => get(state, 'hierarchies');
export const getOrganizationsData = state => get(state, 'hierarchies.organizationsData');
export const getOrganizationByIdData = (state, orgId: string) =>
  get(state, 'hierarchies.organizationsData').find(org => org.uuid === orgId);

export const getSitesData = state => get(state, 'hierarchies.sitesData');
export const getActiveSitesData = state =>
  get(state, 'hierarchies.sitesData').filter(site => site.status === ResourceSatus.ACTIVE);

export const getActiveSitesForOrgData = (state, orgId: string) =>
  get(state, 'hierarchies.sitesData').filter(
    site => site.status === ResourceSatus.ACTIVE && site.orgUUId === orgId
  );
export const getSiteByIdData = (state, siteId: string) =>
  get(state, 'hierarchies.sitesData').find(site => site.uuid === siteId);
export const getSystemsData = state => get(state, 'hierarchies.systemsData');

export const getSystemByIdData = (state, systemId: string) =>
  get(state, 'hierarchies.systemsData').find(system => system.uuid === systemId);

export const getSublocationsForLocation = state => get(state, 'hierarchies.sublocationsData');
export const getLocationsData = state => get(state, 'hierarchies.locationsData');
export const getLocationsForSiteData = state => get(state, 'hierarchies.locationsForSiteData');

export const getLocationByIdData = (state, locationId: string) =>
  get(state, 'hierarchies.locationsData').find(location => location.uuid === locationId) ||
  get(state, 'hierarchies.sublocationsData').find(location => location.uuid === locationId);

export const getAssetByIdData = (state, assetId: string) =>
  get(state, 'hierarchies.assetsData').find(asset => asset.uuid === assetId);
export const getAssetTypesData = state => get(state, 'hierarchies.assetTypesData');
export const getAssetsData = state => get(state, 'hierarchies.assetsData');
export const getParentAssetsData = state => get(state, 'hierarchies.parentAssetsData');
export const getSubAssetsData = state => get(state, 'hierarchies.subAssetsData');

export const getDeviceTypesData = state => get(state, 'hierarchies.deviceTypesData');
export const getDeviceTypeDataByIdData = (state, deviceType: string) =>
  get(state, 'hierarchies.deviceTypesData').find(dT => dT.uuid === deviceType);

export const getDevicesData = state => get(state, 'hierarchies.devicesData');

export const getDimensionsData = state => get(state, 'hierarchies.dimensionsData');
export const getDeviceTypeDimensionsData = state =>
  get(state, 'hierarchies.deviceTypeDimensionsData');
export const getDeviceTypeData = (state, deviceTypeUUID: string) =>
  get(state, 'hierarchies.deviceTypeData').find(dT => dT.uuid === deviceTypeUUID);
export const getHierarchyTableState = state => get(state, 'hierarchies.hierarchyTableState');
export const getDeviceData = state => get(state, 'hierarchies.deviceData');
export const getDeviceByIdData = (state, deviceId: string) =>
  get(state, 'hierarchies.devicesData').find(device => device.name === deviceId);

export const getDeviceByIdAndTypeData = (state, deviceId: string, deviceType: string) =>
  get(state, 'hierarchies.devicesData').find(
    device => device.name === deviceId && device.deviceTypeName === deviceType
  );

export const getNewDevices = state => get(state, 'hierarchies.newDevices');
